import Type, {} from 'typebox';
// Based on https://github.com/sinclairzx81/typebox/discussions/828#discussioncomment-9146556
export const DiscriminatedUnion = (members, { discriminator }) => {
    return Type.Unsafe({
        oneOf: members,
        type: 'object',
        discriminator: { propertyName: discriminator },
        required: [discriminator],
    });
};
//# sourceMappingURL=typebox.js.map